import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { GiSettingsKnobs } from 'react-icons/gi'
import { MdOutlinePayments } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { SubAccount } from '../../api/services/dd_panel_sub_accounts/types.ts'
import { subscriptionAPI } from '../../api/services/subscription'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Popup from '../../components/common/Popup/Popup.tsx'
import SubscriptionPopup from '../../components/subscriptons/Subscription/SubscriptionPopup.tsx'
import { useAuth } from '../../context/auth'
import { getLocalAgreement } from '../../utils/agreement/getLocalAgreement.ts'

const Subscriptions = ({
  setStep,
  subAccount,
  isRestrictedUser,
  isPanelUser,
  refetch
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>
  subAccount: SubAccount | null
  isRestrictedUser: boolean
  isPanelUser: boolean
  refetch: () => void
}) => {
  const navigate = useNavigate()
  const { state } = useAuth()
  const url = new URL(window.location.href)
  const message = url.searchParams.get('message')
  const step = url.searchParams.get('step')
  const [receivedMessage, setReceivedMessage] = useState<string | null>()
  const [receivedStep, setReceivedStep] = useState<string | null>()
  const [loader, setLoader] = useState(false)
  const agreementStep = getLocalAgreement(state.email)
  const initialState = agreementStep
  const [isPopupVisible, setIsPopupVisible] = useState(false)

  useEffect(() => {
    window.close()
    if (window.opener && message && step) {
      window.opener.postMessage({ message, step }, window.location.origin)
    }
  }, [])

  useEffect(() => {
    const receiveMessage = (event: MessageEvent) => {
      if (
        event.origin === window.location.origin &&
        event.data?.message &&
        event.data?.step
      ) {
        setReceivedMessage(event.data?.message)
        setReceivedStep(event.data?.step)
        if (event.data && event.data?.step === '4') {
          localStorage.setItem(
            'agreement-' + state.email,
            JSON.stringify({ user: state.email, step: '4' })
          )
          refetch()
          setStep(Number(step))
        }
      }
    }

    window.addEventListener('message', receiveMessage)
    return () => window.removeEventListener('message', receiveMessage)
  }, [])

  useEffect(() => {
    if (receivedMessage) {
      setIsPopupVisible(false)
      receivedStep === '3'
        ? toast.error(receivedMessage)
        : toast.success(receivedMessage)
    }
  }, [receivedMessage])

  useEffect(() => {
    if (agreementStep !== initialState) {
      setStep(5)
    }
  }, [agreementStep])

  const handleManageSubscription = async () => {
    setLoader(true)
    try {
      const response = await subscriptionAPI.getCustomerPortalLink()
      if (response.checkout_session) {
        const url = response.checkout_session
        window.open(url, '_blank')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }
  }

  return (
    <div className={'mt-6'}>
      <Breadcrumbs pageName="Subskrypcja" breadcrumbs={[]} />

      {!receivedMessage && (
        <div className="text-[20px] text-red-400">
          {/*{agreementStep === '4'*/}
          {agreementStep === '3'
            ? 'Proszę wybrać plan subskrypcji i dokonać płatności.'
            : ''}
          {!agreementStep || agreementStep === '1'
            ? 'Brak uzupełnionych danych firmowych -'
            : ''}
          {agreementStep === '1' && (
            <button
              className="px-4 text-[18px] text-blue-500"
              onClick={() => navigate('/account/business-details/')}
            >
              Cofnij
            </button>
          )}
          {agreementStep === '2' ? 'Brak akceptacji umowy -' : ''}
          {agreementStep === '2' && (
            <button
              className="px-4 text-[18px] text-blue-500"
              onClick={() => navigate('/account/usage-policy/')}
            >
              Cofnij
            </button>
          )}
        </div>
      )}
      {receivedMessage && (
        <div
          className={classNames(
            ' text-[20px]',
            receivedStep === '3' && 'text-red-400'
          )}
        >
          {receivedStep === '3' && receivedMessage}
        </div>
      )}

      {Number(agreementStep) > 2 && (
        <div className="mt-6">
          <Card>
            <Card.Body>
              <div className={'flex flex-1 pt-6'}>
                <>
                  {isRestrictedUser && (
                    <Button
                      variant="filled"
                      size="medium"
                      color="primary"
                      onClick={() => setIsPopupVisible(true)}
                      disabled={Number(agreementStep) < 3}
                      icon={<MdOutlinePayments size={22} />}
                    >
                      {'Pokaż dostępne plany subskrypcji'}
                    </Button>
                  )}
                  {(!isRestrictedUser ||
                    (isPanelUser && subAccount?.agreement_exists)) && (
                    <Button
                      variant="filled"
                      size="medium"
                      color="primary"
                      onClick={handleManageSubscription}
                      disabled={loader}
                      icon={<GiSettingsKnobs size={22} />}
                    >
                      {loader
                        ? 'Trwa przekierowanie ...'
                        : 'Zarządzaj subskrypcją'}
                    </Button>
                  )}
                </>
              </div>
            </Card.Body>
          </Card>
          <Popup
            isVisible={isPopupVisible}
            onClose={() => setIsPopupVisible(false)}
            size={'small'}
          >
            <SubscriptionPopup />
          </Popup>
        </div>
      )}
    </div>
  )
}

export default Subscriptions
